import React, { useMemo, useState } from 'react'
import { Row, Col, Input } from 'antd'
import { cloneDeep } from 'lodash'
import styled from 'styled-components'
import { icons } from './icons'

const { Search } = Input

const Container = styled.div`
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    .icons-wrapper {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
        height: 80px;
        &:hover {
            background: #2980b9;
            color: #fff;
        }
        > .logo {
            font-size: 24px;
        }
        > .name {
            margin-top: 5px;
            line-height: initial;
        }
    }
    .selected-icon {
        background: #1abc9c;
        color: #fff;
    }
`

const IconSelector = ({ T, selectedIcon, onSelect }) => {
    let [iconList, setIconList] = useState(icons)

    function onSearch(keyword) {
        if (keyword) {
            let allIcons = cloneDeep(icons)
            let searchRegExp = new RegExp(keyword, 'i')
            let searchedIcons = allIcons.filter(item => searchRegExp.test(item))
            setIconList(searchedIcons)
        } else {
            setIconList(icons)
        }
    }

    return (
        <>
            <Search
                style={{ marginBottom: 15 }}
                placeholder={T('ICON_NAME')}
                onSearch={value => onSearch(value)}
                enterButton
            />
            <Container>
                <Row type="flex" gutter={5}>
                    {iconList.map(icon => (
                        <Col key={icon} xs={6}>
                            <div
                                className={`icons-wrapper ${
                                    selectedIcon == icon ? 'selected-icon' : ''
                                }`}
                                onClick={() => onSelect(icon)}>
                                <div className="logo">
                                    <i className={`icon-${icon}`} />
                                </div>
                                <div className="name">{icon}</div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </>
    )
}

export default IconSelector
